import { Tutorial } from '@components/tutorial/Tutorial';
import { useTranslation } from 'react-i18next';
import { Step } from 'react-joyride';

export function UpgradeTutorial() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Tutorial.Upgrade' });

  const steps: Step[] = [
    {
      target: '.level-tutorial',
      placement: 'center',
      content: t('upgrade0'),
    },
    {
      target: '.level-tutorial',
      placement: 'top',
      content: t('upgrade1'),
    },
    {
      target: '.mod-tutorial',
      placement: 'top',
      content: t('upgrade2'),
    },
    {
      target: '.tutorial-slot-0',
      placement: 'top',
      content: <p className="text-primary">{t('upgrade3')}</p>,
    },
    {
      target: '.nav-navigation',
      placement: 'top',
      content: t('upgrade4'),
    },
  ];

  return <Tutorial tutorialKey="Upgrade" steps={steps} />;
}